export default {"src":"/_next/static/media/cup-dark-icon.aa7d0376.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};